import { formatUiDateTime } from "./dateFormats";

export function mapOpenPositionRecord(item, rowId = 0) {
  const type = item.type || item.Type || "";
  const isBuy = String(type).toLowerCase() === "buy";
  const qty = Math.abs(Number(item.qty ?? item.Qty) || 0);
  const lots = Math.abs(Number(item.lots ?? item.Lots) || 0);
  const signedQty = isBuy ? qty : qty ? -qty : 0;
  const signedLot = isBuy ? lots : lots ? -lots : 0;
  const openPrice = Number(item.openPrice ?? item.OpenPrice) || 0;
  const currentPrice = Number(item.currentPrice ?? item.CurrentPrice) || 0;
  const profit = Number(item.profit ?? item.Profit) || 0;

  return {
    ...item,
    positionId: item.positionId ?? item.PositionId,
    segment: item.segment ?? item.Segment,
    segmentId: item.segmentId ?? item.SegmentId,
    segmentCode: item.segmentCode ?? item.SegmentCode,
    clientName: item.clientName ?? item.ClientName,
    authorityName: item.authorityName ?? item.AuthorityName,
    symbol: item.symbol ?? item.Symbol,
    script: item.script ?? item.Script ?? item.symbol,
    displayName:
      item.displayName ??
      item.DisplayName ??
      item.script ??
      item.Script ??
      item.symbol,
    token: item.token ?? item.Token,
    exDate: item.exDate ?? item.ExDate,
    openTime: item.openTime ?? item.OpenTime,
    type,
    lots,
    qty,
    openPrice,
    currentPrice,
    profit,
    positionDataType: item.positionDataType ?? item.PositionDataType ?? 1,
    currencyRate: item.currencyRate ?? item.CurrencyRate ?? 1,
    currencySymbol: item.currencySymbol ?? item.CurrencySymbol ?? "",
    digitAfterPoint: item.digitAfterPoint ?? item.DigitAfterPoint ?? 2,
    fatakBalance: item.fatakBalance ?? item.FatakBalance ?? 0,
    ledgerBalance: item.ledgerBalance ?? item.LedgerBalance ?? 0,
    userId: item.userId ?? item.UserId,
    netQty: signedQty,
    netLot: signedLot,
    ltp: currentPrice,
    mtm: profit,
    orderType: type,
    rowId,
  };
}

export function mapOpenPositionRecords(records = [], startIndex = 0) {
  return (records || []).map((item, idx) =>
    mapOpenPositionRecord(item, startIndex + idx + 1)
  );
}

/**
 * On API refresh, keep live MTM (currentPrice / profit / ltp / mtm) from the
 * previous UI row for the same positionId so auto-refresh does not flash
 * stale DB PriceCurrent / UnrealizedPnl (often 0) for a few ms.
 */
export function mergeLiveMtmIntoOpenPositions(apiRows = [], existingRows = []) {
  if (!existingRows?.length) return apiRows || [];

  const liveById = new Map();
  for (const row of existingRows) {
    const id = row?.positionId;
    if (id == null || id === "") continue;
    const currentPrice = Number(row.currentPrice ?? row.ltp);
    if (!Number.isFinite(currentPrice) || currentPrice <= 0) continue;
    liveById.set(String(id), {
      currentPrice,
      ltp: Number(row.ltp ?? currentPrice) || currentPrice,
      profit: Number(row.profit ?? row.mtm) || 0,
      mtm: Number(row.mtm ?? row.profit) || 0,
      isCheck: !!row.isCheck,
    });
  }

  if (liveById.size === 0) return apiRows || [];

  return (apiRows || []).map((row) => {
    const live = liveById.get(String(row.positionId));
    if (!live) return row;
    return {
      ...row,
      currentPrice: live.currentPrice,
      ltp: live.ltp,
      profit: live.profit,
      mtm: live.mtm,
      isCheck: live.isCheck,
    };
  });
}

export function formatOpenPositionTime(value) {
  return formatUiDateTime(value, "");
}

export function applyLiveQuoteToOpenPosition(row, tick) {
  if (!tick?.Script || row.displayName !== tick.Script) return row;
  const { LTP, Bid, Ask } = tick;
  const cal_ltp =
    row.positionDataType == 1 ? LTP : Number(row.netQty) > 0 ? Bid : Ask;
  const qty = Math.abs(Number(row.qty ?? row.netQty) || 0);
  const open = Number(row.openPrice) || 0;
  const isBuy =
    String(row.type || "").toLowerCase() === "buy" || Number(row.netQty) > 0;
  const profit = isBuy ? (cal_ltp - open) * qty : (open - cal_ltp) * qty;
  const rounded = parseFloat(Number(profit).toFixed(2));
  return {
    ...row,
    currentPrice: cal_ltp,
    ltp: cal_ltp,
    profit: rounded,
    mtm: rounded,
  };
}
